import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import moment from 'moment';
import memoizeOne from 'memoize-one';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core';
import { FHETable } from 'data/components';
import renderEnvComponent from 'data/common/renderEnvComponent';
import getSelectors from '../selectors';

class TableHomeProducts extends PureComponent {
    static propTypes = {
        events: PropTypes.array.isRequired,
        history: PropTypes.object.isRequired,
        loading: PropTypes.bool.isRequired
    };

    getMessageFromData = (message, type, data) => {
        const { product_identifier, product_type, product_code, value, ...restArgs } = data;
        const productModuleLabel =
            typeof product_identifier !== 'undefined' ? product_identifier : Translator.translate('general.activities.undefined_product_label');
        return typeof value !== 'undefined'
            ? Translator.translate(`general.activities.${type}.${message}.${value}`, productModuleLabel, ...Object.values(restArgs))
            : Translator.translate(`general.activities.${type}.${message}`, productModuleLabel, ...Object.values(restArgs));
    };

    renderData = memoizeOne(events => {
        let result = [];

        events.forEach(event => {
            const message = this.getMessageFromData(event.message, event.type, event.data);
            result.push({
                home: event.home,
                timestamp: moment.unix(event.timestamp).format('DD/MM/YYYY HH:MM:ss'),
                data: event.data,
                message,
                product_code: event.product_code,
                product_identifier: event.product_identifier && event.product_identifier.match(/.{1,2}/g).join(':'),
                product_type: event.product_type,
                type: event.type
            });
        });
        return result;
    });

    renderColumns = memoizeOne(() => {
        return [
            {
                title: Translator.translate('general.table.column.date'),
                name: 'timestamp',
                defaultSort: 'desc'
            },
            {
                title: Translator.translate('general.table.column.identifier'),
                name: 'product_identifier'
            },
            {
                title: Translator.translate('general.table.column.message'),
                name: 'message'
            }
        ];
    });

    render() {
        const { events, loading, history } = this.props;

        return (
            <FHETable
                idTable="homeDetailJournalisation"
                isLoading={loading}
                columns={this.renderColumns()}
                data={this.renderData(events)}
                minified
                emptyDataSourceMessage={Translator.translate(`generic.home.journalisation.table.body.emptyDataSourceMessage`)}
            />
        );
    }
}
function mapStateToProps(state, props) {
    const { history } = props;
    const selectors = getSelectors(history.environment);
    return {
        profile: selectors.getProfile(state)
    };
}

const styles = () => ({
    loadingContainer: {
        textAlign: 'center',
        margin: 20
    }
});

export default withRouter(
    renderEnvComponent(
        'scenes/Home/tables/TableHomeJournalisation',
        connect(mapStateToProps)(withStyles(styles, { withTheme: true })(TableHomeProducts))
    )
);



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Home/tables/TableHomeJournalisation.js